import { ISelectData } from '../../../../../common/components/select-autocomplete/interfaces/ISelectData';
import ICarriersResponse from '../../../../carriers/interfaces/ICarriersResponse';
import CarriersService from '../../../../carriers/services/carriers.service';

const carrierFilterOnChange = (
    ids: string[],
    carriers: ISelectData[],
    selectedCarriers: ISelectData[],
) => {
    const data = [] as ISelectData[];

    ids.forEach(id => {
        const carrier = carriers.find(carrier => carrier.value === id);
        const wasSelected = selectedCarriers.find(
            carrier => carrier.value === id,
        );

        if (carrier) {
            data.push(carrier);
        } else if (wasSelected) {
            data.push(wasSelected);
        }
    });

    return data;
};

const carrierMap = (data: ICarriersResponse[]) => {
    return data.map(
        carrier =>
            ({
                label: carrier.tradeName,
                value: carrier.id,
            }) as ISelectData,
    );
};

const getCarriersList = async (
    value?: string,
): Promise<ISelectData[] | undefined> => {
    const filter = value ? { carrierName: value } : {};

    const response = await CarriersService.getCarriersList(1, 20, filter).catch(
        () => {
            throw new Error(
                'Ocorreu um problema ao consultar as transportadoras',
            );
        },
    );

    if (response?.data) {
        const carriers = carrierMap(response.data);
        return carriers;
    }

    return undefined;
};

export default (() => {
    return {
        carrierFilterOnChange,
        getCarriersList,
        carrierMap,
    };
})();
